import type {PullRequestMergeRequirementsPayload} from '../page-data/payloads/merge-box'

const THREAD_RESOLUTION_FAILURE_REASON = 'thread_resolution_required'

/**
 * Determines whether resolving review conversations is a required check to merge
 * for this repository. The rules engine surfaces this either as a dedicated
 * `REQUIRED_REVIEW_THREAD_RESOLUTION` rule or as a `thread_resolution_required`
 * failure reason on the `PULL_REQUEST` rule rollup.
 */
export function isConversationResolutionRequired(
  mergeRequirements: PullRequestMergeRequirementsPayload | null | undefined,
): boolean {
  if (!mergeRequirements) return false

  for (const condition of mergeRequirements.conditions) {
    if (!('ruleRollups' in condition)) continue

    for (const rollup of condition.ruleRollups) {
      if (rollup.ruleType === 'REQUIRED_REVIEW_THREAD_RESOLUTION') return true

      if (rollup.metadata && 'failureReasons' in rollup.metadata) {
        if (rollup.metadata.failureReasons.some(reason => reason.toLowerCase() === THREAD_RESOLUTION_FAILURE_REASON)) {
          return true
        }
      }
    }
  }

  return false
}
